import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import SearchSupplier from '../../components/SearchSupplier';
import axios from 'axios';
import { setLoading } from '../../redux/actions/loader.action';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { dateFormat, endpointApi } from '../../utils';
import { logout } from '../../redux/actions/auth.action';
import { getBambous, updateElementInList } from '../../redux/actions/bambou.action';
import Paginate from '../../components/Paginate';

export default function BambousPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const bambous = useSelector(state => state.bambous);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const addModal = useRef(null);
    const verificationModal = useRef(null);
    const paymentModal = useRef(null);
    const updateModal = useRef(null);
    const detailsModal = useRef(null);

    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);

    /*
    $table->integer('received_after_counting')->nullable();
    $table->integer('missing_quantity')->nullable();
    $table->decimal('unit_price', 11, 2)->nullable();
    $table->decimal('remaining_amount', 11, 2)->nullable();
    $table->dateTime('payment_date')->nullable();
    $table->enum('payment_method', ['CASH', 'CHEQUE', 'BANK_TRANSFER', 'MVOLA', 'ORANGE_MONEY', 'AIRTEL_MONEY', 'OTHER'])->nullable();
    $table->string('payment_reference', 60)->nullable();
    $table->string('payment_account_number', 30)->nullable();
    $table->text('description')->nullable();
    */

    const [bambou, setBambou] = useState(null);
   
    const [supplier, setSupplier] = useState(null);
    const [code, setCode] = useState("");
    const [receptionDate, setReceptionDate] = useState("");
    const [origin, setOrigin] = useState("");
    const [transportCost, setTransportCost] = useState("");
    const [receivedQuantity, setReceivedQuantity] = useState("");

    const [receivedAfterCounting, setReceivedAfterCounting] = useState("");
    const [missingQuantity, setMissingQuantity] = useState("");

    const [unitPrice, setUnitPrice] = useState("");
    const [remainingAmount, setRemainingAmount] = useState("");
    const [paymentDate, setPaymentDate] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [paymentReference, setPaymentReference] = useState("");
    const [paymentAccountNumber, setPaymentAccountNumber] = useState("");

    const [description, setDescription] = useState("");
    
    const [isReceptionDateTouched, setIsReceptionDateTouched] = useState(false);
    const [isTransportCostTouched, setIsTransportCostTouched] = useState(false);
    const [isReceivedQuantityTouched, setIsReceivedQuantityTouched] = useState(false);
    const [isOriginTouched, setIsOriginTouched] = useState(false);
    const [isReceivedAfterCountingTouched, setIsReceivedAfterCountingTouched] = useState(false);
    const [isMissingQuantityTouched, setIsMissingQuantityTouched] = useState(false);
    const [isUnitPriceTouched, setIsUnitPriceTouched] = useState(false);
    const [isPaymentDateTouched, setIsPaymentDateTouched] = useState(false);
    const [isPaymentMethodTouched, setIsPaymentMethodTouched] = useState(false);
    const [isCodeTouched, setIsCodeTouched] = useState(false);

    const [errors, setErrors] = useState(null);

    useEffect(() => {
        const clickOutsideModal = (e) => {
            if((e.target === addModal.current && addModal.current.classList.contains('active')) || (e.target === updateModal.current && updateModal.current.classList.contains('active')) || (e.target === detailsModal.current && detailsModal.current.classList.contains('active')) || (e.target === verificationModal.current && verificationModal.current.classList.contains('active')) || (e.target === paymentModal.current && paymentModal.current.classList.contains('active'))){
                setModal(null);
            }
        }
        document.addEventListener('click', clickOutsideModal);
        return () => {
            document.removeEventListener('click', clickOutsideModal);
        }
    }, []);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    useEffect(() => {
        dispatch(getBambous(location, navigate));
    }, [location, dispatch, navigate]);

    useEffect(() => {
        if(modal === null){
            setCode('');
            setSupplier(null);
            setReceptionDate('');
            setOrigin('');
            setReceivedQuantity('');
            setTransportCost('');

            setReceivedAfterCounting("");
            setMissingQuantity("");
            
            setUnitPrice('');
            setRemainingAmount('');
            setPaymentDate('');
            setPaymentMethod('');
            setPaymentAccountNumber('');
            setPaymentReference('');

            setIsReceptionDateTouched(false);
            setIsOriginTouched(false);
            setIsReceivedQuantityTouched(false);
            setIsTransportCostTouched(false);
            setIsReceivedAfterCountingTouched(false);
            setIsMissingQuantityTouched(false);
            
            setIsUnitPriceTouched(false);
            setIsPaymentDateTouched(false);
            setIsPaymentMethodTouched(false);
            setIsCodeTouched(false);
        }
        if(modal){
            const $modals = document.querySelectorAll('._modal-content');
            $modals.forEach($modal => {
                $modal.scrollTop = 0;
            })
        }
    }, [modal]);

    useEffect(() => {
        if(bambou && modal !== null && modal !== 'add' && modal !== "details"){
            setCode(bambou.code);
            setSupplier(bambou.supplier);
            setReceptionDate(bambou.reception_date);
            setOrigin(bambou.origin);
            setReceivedQuantity(bambou.received_quantity);
            setTransportCost(bambou.transport_cost);

            setReceivedAfterCounting(bambou.received_after_counting !== null ? bambou.received_after_counting : "");
            setMissingQuantity(bambou.missing_quantity !== null ? bambou.missing_quantity : "");
            
            setUnitPrice(bambou.unit_price !== null ? bambou.unit_price : "");
            setRemainingAmount(bambou.remaining_amount !== null ? bambou.remaining_amount : "");
            setPaymentDate(bambou.payment_date !== null ? bambou.payment_date : "");
            setPaymentMethod(bambou.payment_method !== null ? bambou.payment_method : "");
            setPaymentAccountNumber(bambou.payment_account_number !== null ? bambou.payment_account_number : "");
            setPaymentReference(bambou.payment_reference !== null ? bambou.payment_reference : "");
        }
    }, [modal, bambou]);

    useEffect(() => {
        if(receivedAfterCounting > 0 && receivedQuantity > 0){
            setMissingQuantity(receivedQuantity - receivedAfterCounting);
        }else{
            setMissingQuantity("");
        }
    }, [receivedAfterCounting, receivedQuantity]);

    useEffect(() => {
        if(unitPrice > 0 && receivedAfterCounting && unitPrice !== null && receivedAfterCounting !== null){
          setRemainingAmount(unitPrice * receivedAfterCounting);
        }else{
          setRemainingAmount("");
        }
    }, [unitPrice, receivedAfterCounting]);

    const handleSubmitAdd = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);

        await axios.post(`${ endpointApi }bambous`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`      
                        }
                    })
                    .then(({ data }) => {
                        dispatch(getBambous(location, navigate));
                        setBambou(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }
    
    const handleSubmitVerification = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);

        await axios.put(`${ endpointApi }bambous/${ bambou?.id }/verification`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`      
                        }
                    })
                    .then(({ data }) => {
                        dispatch(updateElementInList(data));
                        setBambou(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }
    
    const handleSubmitPayment = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);

        await axios.put(`${ endpointApi }bambous/${ bambou?.id }/payment`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`      
                        }
                    })
                    .then(({ data }) => {
                        dispatch(updateElementInList(data));
                        setBambou(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }
    
    const handleSubmitUpdate = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);

        await axios.put(`${ endpointApi }bambous/${ bambou?.id }`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`      
                        }
                    })
                    .then(({ data }) => {
                        dispatch(updateElementInList(data));
                        setBambou(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    return (
        <HelmetProvider>
            <Helmet>
                <title>Matières premières : Bambous - Société Mikalo</title>
            </Helmet>

            <div className='title d-flex justify-content-between'>
                <h1>Matières premières : Bambous</h1>
                <button type='button' className='btn btn-primary' onClick={ () => setModal('add') }><i className='fa fa-plus'></i> Ajouter</button>
            </div>

            <div ref={ addModal } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        <h4>Ajout de matière première: Bambou</h4>
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div>
                    <div className='_modal-body'>
                        <form className='form' onSubmit={ handleSubmitAdd }>
                            <div className='mb-3'>
                                <label htmlFor='reception_date' className='required'>Date de réception</label>
                                <input type='date' id='reception_date' name='reception_date' className='form-control' value={ receptionDate } onChange={ (e) => setReceptionDate(e.target.value) } onBlur={ () => setIsReceptionDateTouched(true) } required />
                                { isReceptionDateTouched && receptionDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de réception.</div> }
                                { errors && errors.reception_date && <div className='form-error'>{ errors.reception_date[0] }</div> }
                            </div>
                            <div className='pb-3'>
                                <label htmlFor='supplier_id' className='required'>Nom du fournisseur</label>
                                <input type='hidden' name='supplier_id' value={ supplier ? supplier.id : '' } />
                                <SearchSupplier required={ true } updateSupplier={ setSupplier } defaultValue={ supplier } reset={ modal !== "add" } />
                                { errors && errors.supplier_id && <div className='form-error'>{ errors.supplier_id[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='origin' className='required'>Origine</label>
                                <input type='text' id='origin' name='origin' className='form-control' placeholder='Origine' value={ origin } required onChange={ (e) => setOrigin(e.target.value) } onBlur={ () => setIsOriginTouched(true) } />
                                { isOriginTouched && origin.length === 0 && <div className='form-error'>Veuillez saisir l'origine de la matière première.</div> }
                                { isOriginTouched && origin.length > 0 && origin.length < 2 && <div className='form-error'>L'origine de la matière première est trop courte. Veuillez saisir au moins 2 caractères.</div> }
                                { errors && errors.origin && <div className='form-error'>{ errors.origin[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='transport_cost' className='required'>Coût de transport</label>
                                <input type='number' min={ 0 } step={ 0.01 } id='transport_cost' name='transport_cost' className='form-control' placeholder='Coût de transport' value={ transportCost } required onChange={ (e) => setTransportCost(e.target.value) } onBlur={ () => setIsTransportCostTouched(true) } />
                                { isTransportCostTouched && transportCost.length === 0 && <div className='form-error'>Veuillez saisir le coût de transport.</div> }
                                { errors && errors.transport_cost && <div className='form-error'>{ errors.transport_cost[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='received_quantity' className='required'>Quantité reçue</label>
                                <input type='number' min={ 0 } step={ 1 } id='received_quantity' name='received_quantity' className='form-control' placeholder='Quantité reçue' value={ receivedQuantity } required onChange={ (e) => setReceivedQuantity(e.target.value) } onBlur={ () => setIsReceivedQuantityTouched(true) } />
                                { isReceivedQuantityTouched && receivedQuantity.length === 0 && <div className='form-error'>Veuillez saisir la quantité reçue.</div> }
                                { errors && errors.received_quantity && <div className='form-error'>{ errors.received_quantity[0] }</div> }
                            </div>

                            <div className='pt-2 text-center'>
                                <button type='submit' className='btn btn-lg btn-primary' disabled={
                                    receptionDate.length === 0 || origin.length < 2 || transportCost.length === 0 || supplier === null || receivedQuantity.length === 0
                                }><i className="fa fa-save"></i> Enregistrer</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            <div ref={ verificationModal } className={ `_modal${ modal === 'verification' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        { bambou &&
                        <h4>Vérification: Bambou { bambou.code }</h4> }
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div>
                    <div className='_modal-body'>
                        { bambou && <>
                        <h6 className='__title'>Informations à la réception</h6>
                        <div className='row'>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Date de réception</div>
                                <div className='_value'>{ dateFormat(bambou.reception_date) }</div>
                            </div>
                            
                            <div className='col-6 mb-3'>
                                <div className='_label'>Code</div>
                                <div className='_value'>{ bambou.code }</div>
                            </div>
                        </div>

                        <div className='row'>
                            { bambou.supplier &&
                            <div className='col-6 mb-3'>
                                <div className='_label'>Fournisseur</div>
                                <div className='_value'>{ bambou.supplier.type === 'Company' ? bambou.supplier.company_name : bambou.supplier.last_name + ' ' + bambou.supplier.first_name }</div>
                            </div> }
                            
                            <div className='col-6 mb-3'>
                                <div className='_label'>Origine</div>
                                <div className='_value'>{ bambou.origin }</div>
                            </div>
                            
                            <div className='col-12 mb-3'>
                                <div className='_label'>Quantité reçue</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(bambou.received_quantity) }</div>
                            </div>
                        </div>

                        <div className='mb-3'>
                            <div className='_label'>Coût de transport</div>
                            <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(bambou.transport_cost) } Ariary</div>
                        </div> </>}

                        <h6 className='__title'>Informations après comptage</h6>
                        <form className='form' onSubmit={ handleSubmitVerification }>
                            <div className='mb-3'>
                                <label htmlFor='received_after_counting' className='required'>Quantité aprsè comptage</label>
                                <input type='number' min={ 0 } step={ 1 } id='received_after_counting' name='received_after_counting' className='form-control' placeholder='Quantité après comptage' value={ receivedAfterCounting } required onChange={ (e) => setReceivedAfterCounting(e.target.value) } onBlur={ () => setIsReceivedAfterCountingTouched(true) } />
                                { isReceivedAfterCountingTouched && receivedAfterCounting.length === 0 && <div className='form-error'>Veuillez saisir la quantité après comptage.</div> }
                                { errors && errors.received_after_counting && <div className='form-error'>{ errors.received_after_counting[0] }</div> }
                            </div>
                            
                            <div className='mb-3'>
                                <label htmlFor='missing_quantity' className='required'>Nombre de manquants</label>
                                <input type='number' min={ 0 } step={ 1 } id='missing_quantity' name='missing_quantity' className='form-control' placeholder='Nombre de manquants' value={ missingQuantity } required onChange={ (e) => setMissingQuantity(e.target.value) } onBlur={ () => setIsMissingQuantityTouched(true) } />
                                { isMissingQuantityTouched && missingQuantity.length === 0 && <div className='form-error'>Veuillez saisir le nombre de manquants.</div> }
                                { errors && errors.missing_quantity && <div className='form-error'>{ errors.missing_quantity[0] }</div> }
                            </div>
                            
                            <div className='pt-2 text-center'>
                                <button type='submit' className='btn btn-lg btn-primary' disabled={
                                    receivedAfterCounting.length === 0 || missingQuantity.length === 0
                                }><i className="fa fa-save"></i> Enregistrer</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            <div ref={ paymentModal } className={ `_modal${ modal === 'payment' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        { bambou &&
                        <h4>Paiement: Bambou { bambou.code }</h4> }
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div>
                    <div className='_modal-body'>
                        { bambou && <>
                            <h6 className='__title'>Informations à la réception</h6>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Date de réception</div>
                                    <div className='_value'>{ dateFormat(bambou.reception_date) }</div>
                                </div>
                                
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Code</div>
                                    <div className='_value'>{ bambou.code }</div>
                                </div>
                            </div>

                            <div className='row'>
                                { bambou.supplier &&
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Fournisseur</div>
                                    <div className='_value'>{ bambou.supplier.type === 'Company' ? bambou.supplier.company_name : bambou.supplier.last_name + ' ' + bambou.supplier.first_name }</div>
                                </div> }
                                
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Origine</div>
                                    <div className='_value'>{ bambou.origin }</div>
                                </div>
                                
                                <div className='col-10 mb-3'>
                                    <div className='_label'>Quantité reçue</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(bambou.received_quantity) }</div>
                                </div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Coût de transport</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(bambou.transport_cost) } Ariary</div>
                            </div>

                            { bambou.received_after_counting && <>
                            <h6 className='__title'>Informations après comptage</h6>
                            <div className='mb-3'>
                                <div className='_label'>Quantité après comptage</div>
                                <div className='_value'>{ bambou.received_after_counting ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(bambou.received_after_counting) : "-" }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Nombre de manquants</div>
                                <div className='_value'>{ bambou.missing_quantity ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(bambou.missing_quantity) : "-" }</div>
                            </div>
                            
                            <h6 className='__title'>Informations de paiement</h6>
                            <form className='form' onSubmit={ handleSubmitPayment }>
                                <div className='mb-3'>
                                    <label htmlFor='unit_price' className='required'>Prix unitaire (en Ariary)</label>
                                    <input type='number' min="0" step="0.01" id='unit_price' name='unit_price' className='form-control' placeholder='Prix unitaire (en Ariary)' value={ unitPrice } required onChange={ (e) => setUnitPrice(e.target.value) } onBlur={ () => setIsUnitPriceTouched(true) } />
                                    { isUnitPriceTouched && unitPrice.length === 0 && <div className='form-error'>Veuillez saisir le prix unitaire.</div> }
                                    { errors && errors.unit_price && <div className='form-error'>{ errors.unit_price[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='remaining_amount' className='required'>Montant à payer (en Ariary)</label>
                                    <input type='number' min="0" step="0.01" id='remaining_amount' name='remaining_amount' className='form-control' placeholder='Montant à payer (en Ariary)' value={ remainingAmount } readOnly required onChange={ (e) => remainingAmount(e.target.value) } />
                                    { errors && errors.remaining_amount && <div className='form-error'>{ errors.remaining_amount[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='payment_method' className='required'>Méthode de paiement</label>
                                    <select id='payment_method' name='payment_method' className='form-control' value={ paymentMethod } required onChange={ (e) => setPaymentMethod(e.target.value) } onBlur={ () => setIsPaymentMethodTouched(true) }>
                                        <option value=''>Sélectionner</option>
                                        <option value="CASH">Espèce</option>
                                        <option value="CHEQUE">Chèque</option>
                                        <option value="BANK_TRANSFER">Virement bancaire</option>
                                        <option value="MVOLA">MVola</option>
                                        <option value="ORANGE_MONEY">Orange Money</option>
                                        <option value="AIRTEL_MONEY">Airtel Money</option>
                                        <option value="OTHER">Autre</option>
                                    </select>
                                    { isPaymentMethodTouched && paymentMethod.length === 0 && <div className='form-error'>Veuillez sélectionner la méthode de paiement.</div> }
                                    { errors && errors.payment_method && <div className='form-error'>{ errors.payment_method[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='payment_date' className='required'>Date de paiment</label>
                                    <input type='datetime-local' id='payment_date' name='payment_date' className='form-control' placeholder='Date de paiment' value={ paymentDate } required onChange={ (e) => setPaymentDate(e.target.value) } onBlur={ () => setIsPaymentDateTouched(true) } />
                                    { isPaymentDateTouched && paymentDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de paiement.</div> }
                                    { errors && errors.payment_date && <div className='form-error'>{ errors.payment_date[0] }</div> }
                                </div>

                                { paymentMethod !== 'CASH' &&
                                <>
                                    <div className='mb-3'>
                                        <label htmlFor='payment_account_number'>N° de compte</label>
                                        <input type='text' id='payment_account_number' name='payment_account_number' className='form-control' placeholder='N° de compte' value={ paymentAccountNumber } onChange={ (e) => setPaymentAccountNumber(e.target.value) } />
                                        { errors && errors.payment_account_number && <div className='form-error'>{ errors.payment_account_number[0] }</div> }
                                    </div>

                                    <div className='mb-3'>
                                        <label htmlFor='payment_reference'>Référence de paiement</label>
                                        <input type='text' id='payment_reference' name='payment_reference' className='form-control' placeholder='Référence de paiement' value={ paymentReference } onChange={ (e) => setPaymentReference(e.target.value) } />
                                        { errors && errors.payment_reference && <div className='form-error'>{ errors.payment_reference[0] }</div> }
                                    </div>
                                </> }
                                
                                <div className='pt-2 text-center'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        unitPrice.length === 0 || remainingAmount.length === 0 || paymentMethod.length === 0 || paymentDate.length === 0
                                    }><i className="fa fa-save"></i> Enregistrer</button>
                                </div>
                            </form>
                            </> }
                        </>}
                    </div>
                </div>
            </div>
            
            <div ref={ updateModal } className={ `_modal${ modal === 'update' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        { bambou &&
                        <h4>Bambou { bambou.code }</h4> }
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div>
                    <div className='_modal-body'>
                        <form className='form' onSubmit={ handleSubmitUpdate }>
                            <h6 className='__title'>Informations à la réception</h6>
                            <div className='mb-3'>
                                <label htmlFor='code' className='required'>Code</label>
                                <input type='text' id='code' name='code' className='form-control' value={ code } placeholder='Code' onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } required />
                                { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code bambou.</div> }
                                { isCodeTouched && code.length > 0 && /^[A-Z]{2,5}_FRN\/\d{4}\/\d{4,}$/.test(code) === false && <div className='form-error'>Le code bambou n'est pas valide. Le format valide est XXXXX_FRN/[ANNEE]/[ORDRE].</div> }
                                { errors && errors.code && <div className='form-error'>{ errors.code[0] }</div> }
                            </div>

                            <div className='mb-3'>
                                <label htmlFor='reception_date' className='required'>Date de réception</label>
                                <input type='date' id='reception_date' name='reception_date' className='form-control' value={ receptionDate } onChange={ (e) => setReceptionDate(e.target.value) } onBlur={ () => setIsReceptionDateTouched(true) } required />
                                { isReceptionDateTouched && receptionDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de réception.</div> }
                                { errors && errors.reception_date && <div className='form-error'>{ errors.reception_date[0] }</div> }
                            </div>
                            <div className='pb-3'>
                                <label htmlFor='supplier_id' className='required'>Nom du fournisseur</label>
                                <input type='hidden' name='supplier_id' value={ supplier ? supplier.id : '' } />
                                <SearchSupplier required={ true } updateSupplier={ setSupplier } defaultValue={ supplier } reset={ modal !== "add" } />
                                { errors && errors.supplier_id && <div className='form-error'>{ errors.supplier_id[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='origin' className='required'>Origine</label>
                                <input type='text' id='origin' name='origin' className='form-control' placeholder='Origine' value={ origin } required onChange={ (e) => setOrigin(e.target.value) } onBlur={ () => setIsOriginTouched(true) } />
                                { isOriginTouched && origin.length === 0 && <div className='form-error'>Veuillez saisir l'origine de la matière première.</div> }
                                { isOriginTouched && origin.length > 0 && origin.length < 2 && <div className='form-error'>L'origine de la matière première est trop courte. Veuillez saisir au moins 2 caractères.</div> }
                                { errors && errors.origin && <div className='form-error'>{ errors.origin[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='transport_cost' className='required'>Coût de transport</label>
                                <input type='number' min={ 0 } step={ 0.01 } id='transport_cost' name='transport_cost' className='form-control' placeholder='Coût de transport' value={ transportCost } required onChange={ (e) => setTransportCost(e.target.value) } onBlur={ () => setIsTransportCostTouched(true) } />
                                { isTransportCostTouched && transportCost.length === 0 && <div className='form-error'>Veuillez saisir le coût de transport.</div> }
                                { errors && errors.transport_cost && <div className='form-error'>{ errors.transport_cost[0] }</div> }
                            </div>
                            <div className='mb-3'>
                                <label htmlFor='received_quantity' className='required'>Quantité reçue</label>
                                <input type='number' min={ 0 } step={ 1 } id='received_quantity' name='received_quantity' className='form-control' placeholder='Quantité reçue' value={ receivedQuantity } required onChange={ (e) => setReceivedQuantity(e.target.value) } onBlur={ () => setIsReceivedQuantityTouched(true) } />
                                { isReceivedQuantityTouched && receivedQuantity.length === 0 && <div className='form-error'>Veuillez saisir la quantité reçue.</div> }
                                { errors && errors.received_quantity && <div className='form-error'>{ errors.received_quantity[0] }</div> }
                            </div>
                            
                            { bambou && <>
                                { bambou.received_after_counting && <>
                                <h6 className='__title'>Informations après comptage</h6>
                                <div className='mb-3'>
                                    <label htmlFor='received_after_counting' className='required'>Quantité aprsè comptage</label>
                                    <input type='number' min={ 0 } step={ 1 } id='received_after_counting' name='received_after_counting' className='form-control' placeholder='Quantité après comptage' value={ receivedAfterCounting } required onChange={ (e) => setReceivedAfterCounting(e.target.value) } onBlur={ () => setIsReceivedAfterCountingTouched(true) } />
                                    { isReceivedAfterCountingTouched && receivedAfterCounting.length === 0 && <div className='form-error'>Veuillez saisir la quantité après comptage.</div> }
                                    { errors && errors.received_after_counting && <div className='form-error'>{ errors.received_after_counting[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='missing_quantity' className='required'>Nombre de manquants</label>
                                    <input type='number' min={ 0 } step={ 1 } id='missing_quantity' name='missing_quantity' className='form-control' placeholder='Nombre de manquants' value={ missingQuantity } required onChange={ (e) => setMissingQuantity(e.target.value) } onBlur={ () => setIsMissingQuantityTouched(true) } />
                                    { isMissingQuantityTouched && missingQuantity.length === 0 && <div className='form-error'>Veuillez saisir le nombre de manquants.</div> }
                                    { errors && errors.missing_quantity && <div className='form-error'>{ errors.missing_quantity[0] }</div> }
                                </div>
                                </> }
                            
                                { bambou.payment_date && <>
                                <h6 className='__title'>Informations de paiement</h6>
                                <div className='mb-3'>
                                    <label htmlFor='unit_price' className='required'>Prix unitaire (en Ariary)</label>
                                    <input type='number' min="0" step="0.01" id='unit_price' name='unit_price' className='form-control' placeholder='Prix unitaire (en Ariary)' value={ unitPrice } required onChange={ (e) => setUnitPrice(e.target.value) } onBlur={ () => setIsUnitPriceTouched(true) } />
                                    { isUnitPriceTouched && unitPrice.length === 0 && <div className='form-error'>Veuillez saisir le prix unitaire.</div> }
                                    { errors && errors.unit_price && <div className='form-error'>{ errors.unit_price[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='remaining_amount' className='required'>Montant à payer (en Ariary)</label>
                                    <input type='number' min="0" step="0.01" id='remaining_amount' name='remaining_amount' className='form-control' placeholder='Montant à payer (en Ariary)' value={ remainingAmount } readOnly required onChange={ (e) => remainingAmount(e.target.value) } />
                                    { errors && errors.remaining_amount && <div className='form-error'>{ errors.remaining_amount[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='payment_method' className='required'>Méthode de paiement</label>
                                    <select id='payment_method' name='payment_method' className='form-control' value={ paymentMethod } required onChange={ (e) => setPaymentMethod(e.target.value) } onBlur={ () => setIsPaymentMethodTouched(true) }>
                                        <option value=''>Sélectionner</option>
                                        <option value="CASH">Espèce</option>
                                        <option value="CHEQUE">Chèque</option>
                                        <option value="BANK_TRANSFER">Virement bancaire</option>
                                        <option value="MVOLA">MVola</option>
                                        <option value="ORANGE_MONEY">Orange Money</option>
                                        <option value="AIRTEL_MONEY">Airtel Money</option>
                                        <option value="OTHER">Autre</option>
                                    </select>
                                    { isPaymentMethodTouched && paymentMethod.length === 0 && <div className='form-error'>Veuillez sélectionner la méthode de paiement.</div> }
                                    { errors && errors.payment_method && <div className='form-error'>{ errors.payment_method[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='payment_date' className='required'>Date de paiment</label>
                                    <input type='datetime-local' id='payment_date' name='payment_date' className='form-control' placeholder='Date de paiment' value={ paymentDate } required onChange={ (e) => setPaymentDate(e.target.value) } onBlur={ () => setIsPaymentDateTouched(true) } />
                                    { isPaymentDateTouched && paymentDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date de paiement.</div> }
                                    { errors && errors.payment_date && <div className='form-error'>{ errors.payment_date[0] }</div> }
                                </div>

                                { paymentMethod !== 'CASH' &&
                                <>
                                    <div className='mb-3'>
                                        <label htmlFor='payment_account_number'>N° de compte</label>
                                        <input type='text' id='payment_account_number' name='payment_account_number' className='form-control' placeholder='N° de compte' value={ paymentAccountNumber } onChange={ (e) => setPaymentAccountNumber(e.target.value) } />
                                        { errors && errors.payment_account_number && <div className='form-error'>{ errors.payment_account_number[0] }</div> }
                                    </div>

                                    <div className='mb-3'>
                                        <label htmlFor='payment_reference'>Référence de paiement</label>
                                        <input type='text' id='payment_reference' name='payment_reference' className='form-control' placeholder='Référence de paiement' value={ paymentReference } onChange={ (e) => setPaymentReference(e.target.value) } />
                                        { errors && errors.payment_reference && <div className='form-error'>{ errors.payment_reference[0] }</div> }
                                    </div>
                                </> }
                                </> }
                            </>}
                            <div className='mb-3'>
                                <label htmlFor='description'>Description</label>
                                <textarea id='description' name='description' placeholder='Description' className='form-control' value={ description } onChange={ (e) => setDescription(e.target.value) }></textarea>
                            </div>
                            <div className='pt-2 text-center'>
                                <button type='submit' className='btn btn-lg btn-primary' disabled={ false }><i className="fa fa-save"></i> Enregistrer</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
           
            <div ref={ detailsModal } className={ `_modal${ modal === 'details' ? ' active' : '' }` }>
                <div className='_modal-content'>
                    <div className='_modal-head'>
                        { bambou &&
                        <h4>Bambou { bambou.code }</h4> }
                        <button className='_modal-close' onClick={ () => {
                            setModal(null);
                        }}>&times;</button>
                    </div>
                    <div className='_modal-body'>
                    { bambou && <>
                        <h6 className='__title'>Informations à la réception</h6>
                        <div className='row'>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Date de réception</div>
                                <div className='_value'>{ dateFormat(bambou.reception_date) }</div>
                            </div>
                            
                            <div className='col-6 mb-3'>
                                <div className='_label'>Code</div>
                                <div className='_value'>{ bambou.code }</div>
                            </div>
                        </div>

                        <div className='row'>
                            { bambou.supplier &&
                            <div className='col-6 mb-3'>
                                <div className='_label'>Fournisseur</div>
                                <div className='_value'>{ bambou.supplier.type === 'Company' ? bambou.supplier.company_name : bambou.supplier.last_name + ' ' + bambou.supplier.first_name }</div>
                            </div> }
                            
                            <div className='col-6 mb-3'>
                                <div className='_label'>Origine</div>
                                <div className='_value'>{ bambou.origin }</div>
                            </div>
                            
                            <div className='col-10 mb-3'>
                                <div className='_label'>Quantité reçue</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(bambou.received_quantity) }</div>
                            </div>
                        </div>

                        <div className='mb-3'>
                            <div className='_label'>Coût de transport</div>
                            <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(bambou.transport_cost) } Ariary</div>
                        </div>

                        { bambou.received_after_counting && <>
                        <h6 className='__title'>Informations après comptage</h6>
                        <div className='mb-3'>
                            <div className='_label'>Quantité après comptage</div>
                            <div className='_value'>{ bambou.received_after_counting ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(bambou.received_after_counting) : "-" }</div>
                        </div>
                        <div className='mb-3'>
                            <div className='_label'>Nombre de manquants</div>
                            <div className='_value'>{ bambou.missing_quantity ? new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(bambou.missing_quantity) : "-" }</div>
                        </div>
                        </> }
                        
                        { bambou.received_after_counting && bambou.payment_date && <>
                        <h6 className='__title'>Informations de paiement</h6>
                        <div className='row'>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Prix unitaire</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(bambou.unit_price) } Ariary</div>
                            </div>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Montant à payer</div>
                                <div className='_value'>{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(bambou.remaining_amount) } Ariary</div>
                            </div>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Méthode de paiement</div>
                                <div className='_value'>{ bambou.payment_method === 'CASH' ? 'Espèce' : (bambou.payment_method === 'CHEQUE' ? 'Chèque' : (bambou.payment_method === 'BANK_TRANSFER' ? 'Virement bancaire' : (bambou.payment_method === 'MVOLA' ? 'Mvola' : (bambou.payment_method === 'ORANGE_MONEY' ? 'Orange Money' : (bambou.payment_method === 'AIRTEL_MONEY' ? 'Airtel Money' : 'Autre'))))) }</div>
                            </div>
                            <div className='col-6 mb-3'>
                                <div className='_label'>Date de paiement</div>
                                <div className='_value'>{ dateFormat(bambou.payment_date, "short", true) }</div>
                            </div>
                            { bambou.payment_method !== 'CASH' && <>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Numéro de compte</div>
                                    <div className='_value'>{ bambou.payment_account_number ?? '-'  }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Référence de paiement</div>
                                    <div className='_value'>{ bambou.payment_reference ?? '-' }</div>
                                </div>
                            </> }
                        </div>
                        </> }
                    </>}
                    </div>
                </div>
            </div>

            <div className='box'>
                <table className='table table-striped'>
                    <thead>
                        <tr style={{ verticalAlign: 'middle' }}>
                            <th width="160" rowSpan={ 2 }>Date de réception</th>
                            <th width="200" rowSpan={ 2 }>Code</th>
                            <th className="text-center">Quantité reçue</th>
                            <th className="text-center">Quantité après comptage</th>
                            <th className="text-center">Nombre de manquant</th>
                            <th width="75" className="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    { bambous.loading && <tr><td colSpan={ 6 }>Chargement...</td></tr> }
                    { bambous.loading === false && bambous.data && bambous.data.total === 0 && <tr><td colSpan={ 6 }>Aucun élément trouvé</td></tr> }
                    { bambous.loading === false && bambous.data && bambous.data.data && bambous.data.data.map((item, index) => {
                        return (
                        <tr key={ index }>
                            <td>{ dateFormat(item.reception_date) }</td>
                            <td>{ item.code }</td>
                            <td className="text-center">{ new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.received_quantity) }</td>
                            <td className="text-center">{ item.received_after_counting !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.received_after_counting) : '-' }</td>
                            <td className="text-center">{ item.missing_quantity !== null ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 , maximumFractionDigits: 0}).format(item.missing_quantity) : '-' }</td>
                            <td className="text-end">
                                <div className='actions'>
                                    <button type='button' className='toggle-action' onClick={ (e) => {
                                        e.stopPropagation();
                                        setActionModal(actionModal !== item.id ? item.id : null);
                                    } }><i className='fa fa-ellipsis-v'></i></button>
                                    <ul className={ actionModal === item.id ? 'active' : '' }>
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setBambou(item);
                                            setModal("details");
                                        } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                                        
                                        { item.received_after_counting === null &&
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setBambou(item);
                                            setModal("verification");
                                        } }><i className="fa fa-check-circle"></i> 2e vérification</button></li> }
                                        
                                        { item.received_after_counting !== null && item.payment_method === null &&
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setBambou(item);
                                            setModal("payment");
                                        } }><i className="fa fa-credit-card"></i> Infos de paiement</button></li> }
                                        
                                        <li><button type='button' onClick={ () => {
                                            setActionModal(null);
                                            setBambou(item);
                                            setModal("update");
                                        } }><i className="fa fa-edit"></i> Modifier</button></li>
                                    </ul>
                                </div>
                            </td>
                        </tr> ) })}
                    </tbody>
                </table>
            </div>

            { bambous && bambous.data &&
            <Paginate currentPage={ bambous.data.current_page } totalPages={ bambous.data.last_page } pathname={ location.pathname } search={ location.search } /> }
        </HelmetProvider>
    )
}
